export default __webpack_public_path__ + "static/NeueHaasUnicaProRegular-3bea5dd895c1e9a0fd9d6d0080d22ca7.woff";